var map = {
	"./development": 253,
	"./development.js": 253,
	"./global": 116,
	"./global.js": 116,
	"./production": 254,
	"./production.js": 254
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 595;


//////////////////
// WEBPACK FOOTER
// ./config ^\.\/.*$
// module id = 595
// module chunks = 0